import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#525252",
      d: "M1.334 9.438A6.56 6.56 0 0 0 7.896 16a6.56 6.56 0 0 0 6.562-6.562c0-.364-.253-.624-.617-.624-.35 0-.58.26-.58.617 0 2.965-2.4 5.365-5.365 5.365A5.363 5.363 0 0 1 2.53 9.431c0-2.966 2.4-5.366 5.366-5.366.572 0 1.092.037 1.53.141l-2.214 2.2a.55.55 0 0 0-.171.424c0 .341.253.594.58.594a.6.6 0 0 0 .43-.17l3.062-3.078a.614.614 0 0 0 0-.892L8.06.179A.57.57 0 0 0 7.621 0c-.327 0-.58.268-.58.61 0 .155.052.304.163.423l1.97 1.97a6.559 6.559 0 0 0-7.84 6.436"
    }, null, -1)
  ])))
}
export default { render: render }